import { kebabCase } from "@s-libs/micro-dash";

import { EventProperties } from "@/types/models/EventProperties.interface";
import { PrintOption } from "../../types/PrintOption.interface";

const getPrintButtonEventProperties = (
  option: PrintOption | undefined,
  eventProperties: EventProperties,
  isPrintModal = false,
) => {
  return {
    ...eventProperties,
    streamProperties: {
      ...(eventProperties?.streamProperties ?? {}),
      description: `Print content (${option?.label ?? ""})${isPrintModal ? " from modal" : ""}.`,
      ...(option?.queryParam && {
        selected_option: kebabCase(option.queryParam.toLowerCase()),
      }),
    },
  };
};

export default getPrintButtonEventProperties;
